/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContractMedications
 */
export interface ContractMedications {
    /**
     * 
     */
    specific_medications: Array<string>;
    /**
     * 
     */
    individual_daily_price_threshold: number;
    /**
     * 
     */
    cumulative_daily_price_threshold: number;
}

/**
 * Check if a given object implements the ContractMedications interface.
 */
export function instanceOfContractMedications(value: object): value is ContractMedications {
    if (!('specific_medications' in value) || value['specific_medications'] === undefined) return false;
    if (!('individual_daily_price_threshold' in value) || value['individual_daily_price_threshold'] === undefined) return false;
    if (!('cumulative_daily_price_threshold' in value) || value['cumulative_daily_price_threshold'] === undefined) return false;
    return true;
}

export function ContractMedicationsFromJSON(json: any): ContractMedications {
    return ContractMedicationsFromJSONTyped(json, false);
}

export function ContractMedicationsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractMedications {
    if (json == null) {
        return json;
    }
    return {
        
        'specific_medications': json['specific_medications'],
        'individual_daily_price_threshold': json['individual_daily_price_threshold'],
        'cumulative_daily_price_threshold': json['cumulative_daily_price_threshold'],
    };
}

export function ContractMedicationsToJSON(json: any): ContractMedications {
    return ContractMedicationsToJSONTyped(json, false);
}

export function ContractMedicationsToJSONTyped(value?: ContractMedications | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'specific_medications': value['specific_medications'],
        'individual_daily_price_threshold': value['individual_daily_price_threshold'],
        'cumulative_daily_price_threshold': value['cumulative_daily_price_threshold'],
    };
}

